module.exports = __webpack_public_path__ + "static/media/Santa Clara Street, Brisbane, CA7.43f0ea65.jpg";